<section class="main-content wrapper content-padding" style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">
          {{ bundleProductId ? 'Modifica' : 'Nuovo' }} Prodotto in bundle
          {{ bundleProductId ? bundleProductId : '' }}
        </a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container"></span>
    </div>

    <section class="main-content wrapper">
  <div class="bundle-builder-page">
    <form
      class="bundle-builder-form"
      [formGroup]="bundleProductForm"
      (ngSubmit)="onSubmit()"
      *ngIf="bundleProductForm"
    >
      <!-- Main Bundle Product -->
      <div class="bundle-card hero-card">
        <div class="card-heading">
          <div>
            <h3>Prodotto in bundle</h3>
            <p>Seleziona il prodotto principale. Verranno mostrati solo prodotti con Super Prodotto abilitato.</p>
          </div>

          <span class="status-pill">Super Prodotto</span>
        </div>

        <div class="form-grid single" formGroupName="product">
          <div class="form-field">
            <label>Prodotto Bundle</label>

            <ng-select
              class="service-ng-select"
              [items]="superProducts"
              bindLabel="displayName"
              bindValue="id"
              formControlName="id"
              [searchable]="true"
              [clearable]="true"
              [virtualScroll]="true"
              placeholder="Seleziona prodotto bundle"
              [class.ng-select-error]="getControlError(bundleProductForm.get('product.id'))"
            >
            </ng-select>

            <div
              class="field-error"
              *ngIf="getControlError(bundleProductForm.get('product.id'))"
            >
              Prodotto bundle obbligatorio
            </div>
          </div>
        </div>
      </div>

      <!-- Components -->
      <div class="bundle-card">
        <div class="card-heading">
          <div>
            <h3>Componenti del bundle</h3>
            <p>Configura ogni componente usando un prodotto globale, prodotti specifici per provincia/partner, oppure entrambi.</p>
          </div>

          <button type="button" class="add-component-btn" (click)="addComponent()">
            <i class="fas fa-plus"></i>
            Aggiungi componente
          </button>
        </div>

        <div formArrayName="components" class="components-list">
          <div
            class="component-card"
            *ngFor="let componentForm of components.controls; let ci = index"
            [formGroupName]="ci"
          >
            <div class="component-top">
              <div class="component-badge">
                <span>{{ ci + 1 }}</span>
              </div>

              <div class="component-title">
                <h4>Componente {{ ci + 1 }}</h4>
                <p>Definisci come questo componente viene fornito.</p>
              </div>

              <button
                type="button"
                class="remove-card-btn"
                (click)="removeComponent(ci)"
                [disabled]="components.length === 1"
                title="Rimuovi componente"
              >
                <i class="far fa-trash-alt"></i>
              </button>
            </div>

            <div class="form-grid single">
              <div class="form-field">
                <label>Chiave componente</label>

                <input
                  type="text"
                  class="form-control premium-input"
                  formControlName="componentKey"
                  placeholder="Esempio: rose, cioccolatini"
                  [class.input-error]="getControlError(componentForm.get('componentKey'))"
                />

                <div
                  class="field-error"
                  *ngIf="getControlError(componentForm.get('componentKey'))"
                >
                  Chiave componente obbligatoria
                </div>
              </div>
            </div>

            <div class="sourcing-panel">
              <div class="sourcing-panel-header">
                <h5>Opzioni sorgente componente</h5>
                <span>Puoi scegliere una o entrambe le opzioni</span>
              </div>

              <div class="sourcing-options-grid">
                <!-- Super Province -->
                <label
                  class="sourcing-option-card"
                  [class.active]="componentForm.get('useSuperProvince')?.value"
                >
                  <input
                    type="checkbox"
                    formControlName="useSuperProvince"
                    (change)="handleSuperProvinceToggle(ci)"
                  />

                  <span class="custom-check">
                    <i class="fas fa-check"></i>
                  </span>

                  <span class="option-content">
                    <strong>Super Province Product</strong>
                    <small>Un prodotto globale valido per tutte le province e tutti i partner.</small>
                  </span>
                </label>

                <!-- Unique Products -->
                <label
                  class="sourcing-option-card"
                  [class.active]="componentForm.get('useUniqueProducts')?.value"
                >
                  <input
                    type="checkbox"
                    formControlName="useUniqueProducts"
                    (change)="handleUniqueProductsToggle(ci)"
                  />

                  <span class="custom-check">
                    <i class="fas fa-check"></i>
                  </span>

                  <span class="option-content">
                    <strong>Prodotti provincia / partner</strong>
                    <small>Permette prodotti diversi per provincia e partner.</small>
                  </span>
                </label>
              </div>

              <div
                class="field-error sourcing-error"
                *ngIf="hasComponentSourcingError(componentForm)"
              >
                Seleziona almeno una opzione sorgente per questo componente
              </div>
            </div>

            <!-- Super Province Product -->
            <div
              class="nested-section super-section"
              *ngIf="componentForm.get('useSuperProvince')?.value"
              formGroupName="superProvinceProduct"
            >
              <div class="nested-section-title">
                <i class="fas fa-globe-europe"></i>
                <span>Prodotto globale</span>
              </div>

              <div class="form-grid single">
                <div class="form-field">
                  <label>Prodotto Super Province</label>

                  <ng-select
                    class="service-ng-select"
                    [items]="superProducts"
                    bindLabel="displayName"
                    bindValue="id"
                    formControlName="id"
                    [searchable]="true"
                    [clearable]="true"
                    [virtualScroll]="true"
                    placeholder="Seleziona prodotto globale"
                    [class.ng-select-error]="getControlError(componentForm.get('superProvinceProduct.id'))"
                  >
                  </ng-select>

                  <div
                    class="field-error"
                    *ngIf="getControlError(componentForm.get('superProvinceProduct.id'))"
                  >
                    Prodotto Super Province obbligatorio
                  </div>
                </div>
              </div>
            </div>

            <!-- Unique Products -->
            <div
              class="nested-section unique-section"
              *ngIf="componentForm.get('useUniqueProducts')?.value"
            >
              <div class="nested-section-title with-action">
                <div>
                  <i class="fas fa-map-marker-alt"></i>
                  <span>Prodotti specifici per provincia / partner</span>
                </div>

                <button
                  type="button"
                  class="small-add-btn"
                  (click)="addUniqueProduct(ci)"
                >
                  <i class="fas fa-plus"></i>
                  Aggiungi riga
                </button>
              </div>

              <div formArrayName="uniqueProducts" class="unique-products-list">
                <div
                  class="unique-product-row"
                  *ngFor="
                    let uniqueProductForm of getUniqueProducts(ci).controls;
                    let ui = index
                  "
                  [formGroupName]="ui"
                >
                  <div class="row-number">{{ ui + 1 }}</div>

                  <div class="form-field">
                    <label>Provincia</label>

                    <ng-select
                      class="service-ng-select"
                      [class.ng-select-error]="getControlError(uniqueProductForm.get('provinceId'))"
                      [items]="provinces"
                      bindLabel="province"
                      bindValue="provinceCode"
                      formControlName="provinceId"
                      [searchable]="true"
                      [clearable]="true"
                      placeholder="Provincia"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        <strong>{{ item.provinceCode }}</strong>
                        <span> {{ item.province }}</span>
                      </ng-template>

                      <ng-template
                        ng-label-tmp
                        let-item="item"
                        let-clear="clear"
                      >
                        <strong>{{ item.provinceCode }}</strong>
                        <span> {{ item.province }}</span>

                        <span
                          class="ng-value-icon right"
                          aria-hidden="true"
                          (click)="clear(item)"
                        >
                          ×
                        </span>
                      </ng-template>
                    </ng-select>

                    <div
                      class="field-error"
                      *ngIf="getControlError(uniqueProductForm.get('provinceId'))"
                    >
                      Provincia obbligatoria
                    </div>
                  </div>

                  <div class="form-field" formGroupName="partner">
                    <label>Partner</label>

                    <ng-select
                      class="service-ng-select"
                      [items]="partners"
                      bindLabel="businessName"
                      bindValue="id"
                      formControlName="id"
                      [searchable]="true"
                      [clearable]="true"
                      placeholder="Partner"
                      (change)="handlePartnerChange(ci, ui)"
                      [class.ng-select-error]="getControlError(uniqueProductForm.get('partner.id'))"
                    >
                    </ng-select>

                    <div
                      class="field-error"
                      *ngIf="getControlError(uniqueProductForm.get('partner.id'))"
                    >
                      Partner obbligatorio
                    </div>
                  </div>

                  <div class="form-field" formGroupName="product">
                    <label>Prodotto</label>

                    <ng-select
                      class="service-ng-select"
                      [items]="uniqueProductForm.get('availableProducts')?.value"
                      bindLabel="displayName"
                      bindValue="id"
                      formControlName="id"
                      [searchable]="true"
                      [clearable]="true"
                      [virtualScroll]="true"
                      placeholder="Prodotto"
                      [class.ng-select-error]="getControlError(uniqueProductForm.get('product.id'))"
                    >
                    </ng-select>

                    <div
                      class="field-error"
                      *ngIf="getControlError(uniqueProductForm.get('product.id'))"
                    >
                      Prodotto obbligatorio
                    </div>
                  </div>

                  <button
                    type="button"
                    class="remove-row-btn"
                    (click)="removeUniqueProduct(ci, ui)"
                    title="Rimuovi riga"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom-add-wrapper">
          <button type="button" class="add-component-btn ghost" (click)="addComponent()">
            <i class="fas fa-plus"></i>
            Aggiungi componente
          </button>
        </div>
      </div>

      <!-- Footer actions -->
      <div class="form-actions">
        <button
          type="submit"
          class="save-bundle-btn"
          [disabled]="!bundleProductForm?.valid"
        >
          <i class="far fa-save"></i>
          Salva prodotto in bundle
        </button>
      </div>
    </form>
  </div>
</section>
  </div>
</section>